export interface LoyaltyCardUsersSearchDto {
  locationId: number;
  searchText: string;
}
